export enum ActionType {
  base,
  macro,
  multiMedia,
  deviceFunction,
}

export enum ListenType {
  start = 1,
  end,
}

export enum SetType {
  routine = 0, // 常规
  dks = 1, // 动态键程
  mt = 2, // 按住、单击
  tgl = 3, // 切换开关
  mpt = 4,
  end = 5,
  kme = 6,
  rs = 7,
  macro = 8,
}

// royuan方案增加TGL 两种播放方式：
export enum TriggerType {
  long_press = 0x04, // 长按
  continuous = 0x05, // 连点
}

export enum BaseTabs {
  base = 1, // 基本按键
  extend = 2, //扩展
  compose = 3, // 组合键
  mouse = 4, // 鼠标按键
}
